import { boolean, number, string } from "efform";
const CredentialFormScheme = {
    confirmationCodeDestinationType: string(),
    confirmationCodeType: string(),
    personalConfirmationCode: number(),
    createdAt: number(),
    email: {
        isConfirmed: boolean(false),
        value: string()
    },
    id: string(),
    isBlocked: boolean(false),
    isDeleted: boolean(false),
    phoneNumber: {
        isConfirmed: boolean(false),
        isoTwoLetterCountryCode: string(),
        value: string()
    },
    roles: [{
            isBlocked: boolean(false),
            role: {
                accesses: [
                    {
                        id: string(),
                        method: string(),
                        requestPathPattern: string(),
                        serviceName: string(),
                    }
                ],
                code: string(),
                id: string(),
                name: string(),
            }
        }],
    updatedAt: number(),
    username: string()
};
export default CredentialFormScheme;
//# sourceMappingURL=CredentialFormScheme.js.map